module.exports = __webpack_public_path__ + "static/media/comment-check.8241f8a3.svg";